/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';

// Constants
import CONST_TOKEN from 'constants/token';

// Types
import { ApplicationState } from 'store';

const TokenStatusFilter: React.FC = () => {
  const dispatch = useDispatch();

  const selectedTokenStatus = useSelector(
    (state: ApplicationState) => state.reports.selectedTokenStatus,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      ReportActions.setSelectedTokenStatus({
        selectedTokenStatus: {
          key: (event.target as HTMLInputElement).value,
          value: (event.target as HTMLInputElement).name,
        },
      }),
    );
  };

  return (
    <FormControl component='fieldset'>
      <FormLabel component='legend'>Selecione um status</FormLabel>
      <RadioGroup
        aria-label='token status'
        name='token-status'
        value={selectedTokenStatus ? selectedTokenStatus.key : ''}
        onChange={handleChange}>
        {CONST_TOKEN.STATUS.map((token) => (
          <FormControlLabel
            key={token.KEY}
            name={token.VALUE}
            value={`${token.KEY}`}
            label={token.VALUE}
            control={<Radio color='primary' />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export { TokenStatusFilter };
export default TokenStatusFilter;
